// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_AgendarCompromissoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /agenda/agendar_compromisso
 *
 * Validates input for creating a new compromisso with services.
 */
import type { AgendaServicoNestedInputRow } from './AgendaServicoNestedInputRow'
import { registerContract } from './validate'

export interface Agenda_AgendarCompromissoInput {
title: string
compromisso_total: number
compromisso_franquia_id: number
compromisso_operador_user_id: string
compromisso_data_hora_inicio: string
compromisso_data_hora_fim: string
compromisso_tipo: number
cor_fundo?: string
compromisso_orcamento_id?: number
compromisso_forma_pagamento?: number
compromisso_numero_parcelas?: number
compromisso_origem?: number
servicos?: AgendaServicoNestedInputRow[]
}

registerContract('Agenda_AgendarCompromissoInput', {
  title:                        { type: 'string',  required: true },
  compromisso_total:            { type: 'number',  required: true },
  compromisso_franquia_id:      { type: 'number',  required: true },
  compromisso_operador_user_id: { type: 'string',  required: true },
  compromisso_data_hora_inicio: { type: 'string',  required: true },
  compromisso_data_hora_fim:    { type: 'string',  required: true },
  compromisso_tipo:             { type: 'number',  required: true },
  cor_fundo:                    { type: 'string',  required: false },
  compromisso_orcamento_id:     { type: 'number',  required: false },
  compromisso_forma_pagamento:  { type: 'number',  required: false },
  compromisso_numero_parcelas:  { type: 'number',  required: false },
  compromisso_origem:           { type: 'number',  required: false },
  servicos: {
    type: 'array',
    required: false,
    items: {
      orcamento_servico_id:  { type: 'number',  required: true },
      servico_valor:         { type: 'number',  required: true },
      orcamento_servico_qtd: { type: 'number',  required: true },
    },
  },
})
